import React from "react";

const WarningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="82"
      height="82"
      viewBox="0 0 82 82"
      fill="none"
      className="warning-icon"
    >
      <path
        d="M41 34.0186V47.2655M41 54.426V54.46"
        stroke="#EA6B3D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3553 68.0309H64.6442C65.7464 68.0231 66.83 67.7439 67.8004 67.2176C68.7708 66.6913 69.5986 65.9339 70.2115 65.0114C70.8245 64.089 71.2039 63.0296 71.3169 61.9255C71.4298 60.8215 71.2727 59.7064 70.8593 58.6775L46.8771 17.0124C46.2929 15.9492 45.4365 15.0629 44.397 14.4458C43.3575 13.8287 42.1728 13.5032 40.966 13.5032C39.7593 13.5032 38.5745 13.8287 37.535 14.4458C36.4955 15.0629 35.6391 15.9492 35.0549 17.0124L11.0727 58.6775C10.6671 59.6829 10.5063 60.7713 10.6037 61.8519C10.701 62.9326 11.0537 63.9741 11.6322 64.8896C12.2107 65.805 12.9984 66.5678 13.9293 67.1143C14.8603 67.6608 15.9076 67.9751 16.9838 68.0309"
        stroke="#EA6B3D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WarningIcon;
